export default __webpack_public_path__ + "static/media/downloadCsv.fc2e768d.svg";